import { render, staticRenderFns } from "./HistoricoTipoEquipo.vue?vue&type=template&id=a44c11f6&scoped=true&"
import script from "./HistoricoTipoEquipo.vue?vue&type=script&lang=ts&"
export * from "./HistoricoTipoEquipo.vue?vue&type=script&lang=ts&"
import style0 from "./HistoricoTipoEquipo.vue?vue&type=style&index=0&id=a44c11f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44c11f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('a44c11f6', component.options)
    } else {
      api.reload('a44c11f6', component.options)
    }
    module.hot.accept("./HistoricoTipoEquipo.vue?vue&type=template&id=a44c11f6&scoped=true&", function () {
      api.rerender('a44c11f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/MatrizProducto/HistoricoTipoEquipo.vue"
export default component.exports